// Maps the typed failure code from the OAuth callback to copy written for the
// rep using Zeph — what happened and what they can do about it. The technical
// detail behind each code (which phase failed, Google's own response body)
// lives in the API logs, not here: a rep can't act on "the Calendar API is not
// enabled for this Cloud project", and shouldn't be shown it.
const CONNECT_ERROR_COPY: Record<string, string> = {
  // Google withheld some permissions, either because the rep unticked them on
  // the consent screen (retry fixes it) or because the Google app isn't set up
  // for them (support does).
  google_scope_denied: 'Zeph didn\'t get all the permissions it needs. Try again and accept every permission Google asks for.',
  // Nothing the rep can do — the Google app itself needs attention.
  google_api_disabled: 'Google access isn\'t set up correctly yet. We\'ve logged the details — please contact support.',
  google_token_exchange_failed: 'Google couldn\'t complete the sign-in. Please try again.',
  google_token_rejected: 'Your Google sign-in didn\'t go through. Please try again.',
  google_verification_failed: 'Zeph couldn\'t reach your Gmail and calendar. Please try again.',
  gmail_profile_incomplete: 'Zeph couldn\'t read your Google account details. Please try again.',
  oauth_state_expired: 'That took too long, so Zeph stopped the connection for safety. Please connect again.',
  invalid_state: 'That sign-in link isn\'t valid anymore. Please start the connection again.',
  access_denied: 'The connection was cancelled. You can try again whenever you\'re ready.',
}

const FALLBACK = 'Something went wrong connecting your Google account. Please try again.'

export function connectErrorCopy(reason: string | null): string {
  if (!reason) return FALLBACK
  return CONNECT_ERROR_COPY[reason] ?? FALLBACK
}
